import { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import MainContainer from "../../components/MainContainer";

import {
  BackButton,
  Title,
  Tabs,
  Tab,
  TitleContainer,
  TitleRow,
  ShareButton,
  Content,
  LeftSide,
  MainImg,
  MainVideo,
  RightSide,
  StatsContainer,
  Stat,
  InfoContainer,
  InfoRow,
  InfoLabel,
  InfoValue,
  Tags,
  Tag,
  StatValue,
  StatLabel,
  GenerationSection,
  GenerationTitle,
  GenerationTabsContainer,
  GenerationTab,
  GenerationTabText,
  UploadArea,
  UploadedPreview,
  UploadedVideoPreview,
  PreviewDeleteButton,
  PreviewCropButton,
  UploadIcon,
  UploadText,
  UploadGalleryButton,
  CheckboxGroup,
  CheckboxRow,
  CheckboxLabel,
  NudifyContainer,
  NudifyText,
  GenerateRow,
  SettingsIconWrapper,
  CreditBadge,
  InfoIconButton,
  TooltipContainer,
  TooltipText,
  SettingsContainer,
  SettingsColumn,
  SettingsLabelText,
  SettingsInput,
  SettingsTextarea,
  OptionCheckboxContainer,
  OptionCheckboxRow,
  OptionCheckbox,
  OptionCheckboxText,
  TabContentSection,
  MasonryGrid,
  MasonryColumn,
  EmptyState,
  SkeletonBox,
  SkeletonBoxImage,
  StatIcon,
  CopyContainer,
  ToastWrapper,
  MediaSkeleton,
  AngleDropdownChevron,
  AngleDropdownMenu,
  AngleDropdownOption,
  AngleDropdownTrigger,
  AngleDropdownWrapper,
  AngleDropdownsContainer,
} from "./CollectionDetailsPage.styles";

import { ReactComponent as ChevronLeft } from "../../assets/icons/chevronLeft.svg";
import { ReactComponent as ShareIcon } from "../../assets/icons/share-06.svg";
import { ReactComponent as ImageIcon } from "../../assets/icons/image.svg";
import { ReactComponent as VideoRecorderIcon } from "../../assets/icons/video-recorder.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/info-circle.svg";
import { ReactComponent as UploadCloudIcon } from "../../assets/icons/uploadSvg.svg";
import { ReactComponent as CreditIcon } from "../../assets/icons/credit.svg";
import { ReactComponent as CropIcon } from "../../assets/icons/crop.svg";
import { useMediaQuery } from "react-responsive";
import { formatDate, formatModelName, isImageOutput } from "../../utils/utils";
import GradientStarIcon from "../../components/GradientStarIcon/GradientStarIcon";
import ExploreItem from "../../components/ExploreItem/ExploreItem";
import VideoMasonrySkeletonLoader from "../../components/utils/VideoMasonrySkeletonLoader";

import checkboxAnimation from "../../assets/animations/radioButton.json";
import deleteAnimation from "../../assets/animations/trash.json";
import radioButtonAnimation from "../../assets/animations/radioButton.json";
import settingsAnimation from "../../assets/animations/settings.json";
import fireAnimation from "../../assets/animations/fire.json";
import LottieIcon from "../../components/LottieIcon/LottieIcon";
import CropModal from "../../components/CropModal/CropModal";
import heic2any from "heic2any";

import {
  AUDIO_PRICE,
  BLEND_MODEL,
  CHANGE_ANGLE_MODEL_NAME,
  CREATE_IMAGE_MODEL_NAME,
  DEFAULT_VIDEO_DURATION,
  DEFAULT_VIDEO_FPS,
  DEFAULT_VIDEO_RESOLUTION,
  EDIT_IMAGE_MODEL_NAME,
  MAX_IMAGE_SIZE,
  MAX_VIDEO_SIZE,
  NUDIFY_MODEL_NAME,
  NUDIFY_PRICE,
  QWEN_Z_THREE_INPUT_IMAGES,
  QWEN_Z_TWO_INPUT_IMAGES,
  TEXT_ON_BODY_MODEL_NAME,
  UPSCALE,
  UPSCALE_PRICE,
  VIDEO_DURATION_PRICE,
  VIDEO_FPS_PRICE,
  VIDEO_RESOLUTION_PRICE,
} from "../../utils/constants";
import { toast } from "sonner";
import EnterPromptModal from "../../components/EnterPromptModal/EnterPromptModal";
import CustomizeEditImageModal from "../../components/CustomizeEditImageModal/CustomizeEditImageModal";
import {
  fetchCollection,
  generateBlendCollection,
  generateCollection,
  generateImageCollection,
} from "../../store/slices/model/asyncThunks";
import {
  selectCollectionDetails,
  selectGenerateCollection,
  selectGenerateImageCollectionPending,
  selectSelectedCollection,
  setSelectedCollection,
} from "../../store/slices/model/slice";
import { selectLoggedIn } from "../../store/slices/auth/slice";
import {
  setSignUpModalOpen,
  selectAutoPlay,
} from "../../store/slices/common/slice";
import GenerateCollectionModal from "../../components/GenerateCollectionModal/GenerateCollectionModal";
import EditImageModal from "../../components/EditImageModal/EditImageModal";
import CreateImageModal from "../../components/CreateImageModal/CreateImageModal";
import GroupModal from "../../components/GroupModal/GroupModal";
import UserGalleryModal from "../../components/UserGalleryModal/UserGalleryModal";
import { getSameAuthorCollections } from "../../store/slices/user/asyncThunk";
import GenerationToast from "../../components/utils/GenerationToast";
import ExplosionButton from "../../components/ExplosionButton/ExplosionButton";
import { selectUser } from "../../store/slices/user/slice";

const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const GALLERY_TARGET = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
};

const PAGE_TABS = [
  { name: "Details", id: 1 },
  { name: "Related", id: 2 },
  { name: "Extend With", id: 3 },
  { name: "Same Author", id: 4 },
];

const MODAL_CONTENT = {
  IMAGE_TO_VIDEO: "IMAGE_TO_VIDEO",
  EXTEND_VIDEO: "EXTEND_VIDEO",
};

const WHERE_OPTIONS = [
  { id: "forehead", label: "Forehead" },
  { id: "face", label: "Face" },
  { id: "cheeks", label: "Cheeks" },
  { id: "neck", label: "Neck" },
  { id: "chest", label: "Chest" },
  { id: "tits", label: "Tits" },
  { id: "stomach", label: "Stomach" },
  { id: "pussy", label: "Pussy" },
  { id: "ass", label: "Ass" },
  { id: "dick", label: "Dick" },
  { id: "leg", label: "Leg" },
  { id: "arm", label: "Arm" },
];

const WRITING_STYLE_OPTIONS = [
  { id: "realistic", label: "Realistic" },
  { id: "stylish", label: "Stylish" },
  { id: "extreme", label: "Extreme" },
];

const GETTING_NAKED_OPTIONS = [
  { id: "natural", label: "Natural" },
  { id: "silicone", label: "Silicone" },
];

const HORIZONTAL_ROTATION_OPTIONS = [
  { id: "frontView", label: "Front View" },
  { id: "frontRightQuarterView", label: "Front-Right Quarter View" },
  { id: "rightSideView", label: "Right Side View" },
  { id: "backRightQuarterView", label: "Back-Right Quarter View" },
  { id: "backView", label: "Back View" },
  { id: "backLeftQuarterView", label: "Back-Left Quarter View" },
  { id: "leftSideView", label: "Left Side View" },
  { id: "frontLeftQuarterView", label: "Front-Left Quarter View" },
];

const VERTICAL_ANGLE_OPTIONS = [
  { id: "lowAngleShot", label: "Low-Angle Shot" },
  { id: "eyeLevelShot", label: "Eye-Level Shot" },
  { id: "elevatedShot", label: "Elevated Shot" },
  { id: "highAngleShot", label: "High-Angle Shot" },
];

const DISTANCE_OPTIONS = [
  { id: "closeUp", label: "Close-Up" },
  { id: "mediumShot", label: "Medium Shot" },
  { id: "wideShot", label: "Wide Shot" },
];

const DEFAULT_HORIZONTAL_ROTATION = "frontView";
const DEFAULT_VERTICAL_ANGLE = "lowAngleShot";
const DEFAULT_DISTANCE = "closeUp";

const AngleDropdown = ({ value, options, onChange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const selectedOption = options.find((opt) => opt.id === value);

  return (
    <AngleDropdownWrapper ref={wrapperRef}>
      <AngleDropdownTrigger
        type="button"
        onClick={() => !disabled && setIsOpen((prev) => !prev)}
        disabled={disabled}
      >
        <span>{selectedOption?.label}</span>
        <AngleDropdownChevron $isOpen={isOpen} />
      </AngleDropdownTrigger>
      {isOpen && (
        <AngleDropdownMenu>
          {options.map((option) => (
            <AngleDropdownOption
              key={option.id}
              $selected={option.id === value}
              onClick={() => {
                onChange(option.id);
                setIsOpen(false);
              }}
            >
              {option.label}
            </AngleDropdownOption>
          ))}
        </AngleDropdownMenu>
      )}
    </AngleDropdownWrapper>
  );
};

const CollectionDetailsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fireLoopAnimation = useMemo(
    () => ({
      ...fireAnimation,
      op: Math.max(fireAnimation.ip + 1, fireAnimation.op - 1),
    }),
    [],
  );

  const { data: collectionDetailsData, loading } = useSelector(
    selectCollectionDetails,
  );
  const { loading: generateVideoLoading } = useSelector(
    selectGenerateCollection,
  );
  const generateImageLoading = useSelector(
    selectGenerateImageCollectionPending,
  );
  const generateLoading = generateVideoLoading || generateImageLoading;
  const loggedIn = useSelector(selectLoggedIn);
  const selectedCollection = useSelector(selectSelectedCollection);
  const autoPlay = useSelector(selectAutoPlay);
  const [isExploding, setIsExploding] = useState(false);
  const user = useSelector(selectUser);

  const location = useLocation();
  const { id } = useParams();
  const previewCollection = location.state?.collection;
  const fetchedCollection =
    collectionDetailsData?._id === id ? collectionDetailsData : null;

  const data = useMemo(() => {
    if (!previewCollection) return fetchedCollection ?? null;
    if (!fetchedCollection) return previewCollection;

    return {
      ...previewCollection,
      ...(fetchedCollection.related
        ? { related: fetchedCollection.related }
        : {}),
      ...(fetchedCollection.extend ? { extend: fetchedCollection.extend } : {}),
    };
  }, [fetchedCollection, previewCollection]);

  const isInitialCollectionLoading = loading && !data;

  // ===== Derived flags =====
  const isDoubleInputImageModel = data?.modelType === QWEN_Z_TWO_INPUT_IMAGES;
  const isTripleInputImageModel = data?.modelType === QWEN_Z_THREE_INPUT_IMAGES;
  const isBlendModel = data?.modelType === BLEND_MODEL;
  const isImageModel = data
    ? isImageOutput(data.modelType ?? data.modelName) ||
      isDoubleInputImageModel ||
      isTripleInputImageModel
    : false;
  const isVideoModel = data ? !isImageModel : false;
  const isGettingNakedModel = data?.modelName === NUDIFY_MODEL_NAME;
  const isBodywritingModel = data?.modelName === TEXT_ON_BODY_MODEL_NAME;
  const isEditImageModel = data?.modelName === EDIT_IMAGE_MODEL_NAME;
  const isChangeAngleModel = data?.name === CHANGE_ANGLE_MODEL_NAME;
  const isUpscaleModel = data?.modelType === UPSCALE;
  const hasPromptInput =
    (isEditImageModel && data?.name === "Edit Image") ||
    isDoubleInputImageModel;

  // Main display media from the collection output/input
  const isOutputImage = data?.output?.type === "IMAGE";
  const displayImage =
    data?.input?.image?.url || data?.input?.image?.resizedImage?.url;
  const displayOutputImage = data?.output?.image?.url;
  const displayOutputVideo =
    data?.output?.video?.compressedUrl || data?.output?.video?.url;

  // ===== Page tab state =====
  const [activeTab, setActiveTab] = useState(PAGE_TABS[0].name);

  // ===== Tab content states (Same Author) =====
  const [sameAuthorData, setSameAuthorData] = useState({
    data: null,
    loading: false,
    total: 0,
    page: 1,
  });

  // ===== Video generation state =====
  const [generationTab, setGenerationTab] = useState(
    MODAL_CONTENT.IMAGE_TO_VIDEO,
  );

  // ===== Shared generation state =====
  const [uploadedImage, setUploadedImage] = useState(null);
  const [nudifyEnabled, setNudifyEnabled] = useState(false);
  const [upscaleEnabled, setUpscaleEnabled] = useState(false);
  const [audioEnabled, setAudioEnabled] = useState(
    localStorage.getItem("audioEnabled") === "true",
  );

  const [showTooltip, setShowTooltip] = useState(false);

  // ===== Image generation state =====
  const [bodyWritingText, setBodyWritingText] = useState("");
  const [where, setWhere] = useState("face");
  const [writingStyle, setWritingStyle] = useState("realistic");
  const [nakedStyle, setNakedStyle] = useState("natural");
  const [horizontalRotation, setHorizontalRotation] = useState(
    DEFAULT_HORIZONTAL_ROTATION,
  );
  const [verticalAngle, setVerticalAngle] = useState(DEFAULT_VERTICAL_ANGLE);
  const [distance, setDistance] = useState(DEFAULT_DISTANCE);
  const [customPrompt, setCustomPrompt] = useState("");
  const [negativePrompt, setNegativePrompt] = useState("");
  const [audioPrompt, setAudioPrompt] = useState("");
  const [shouldEnhancePrompt, setShouldEnhancePrompt] = useState(false);
  const [seedNumber, setSeedNumber] = useState(
    Math.floor(Math.random() * 10000000) + 1,
  );
  const [showPrompts, setShowPrompts] = useState(false);
  const [videoResolution, setVideoResolution] = useState(
    localStorage.getItem("videoResolution") ?? DEFAULT_VIDEO_RESOLUTION,
  );
  const [fps, setFps] = useState(
    Number(localStorage.getItem("videoFps") ?? DEFAULT_VIDEO_FPS),
  );
  const [videoDuration, setVideoDuration] = useState(
    Number(localStorage.getItem("videoDuration") ?? DEFAULT_VIDEO_DURATION),
  );

  const [isEnterPromptModalOpen, setIsEnterPromptModalOpen] = useState(false);
  const [isOpenCustomizePromptModalOpen, setIsOpenCustomizePromptModalOpen] =
    useState(false);
  const [isGenerateCollectionModalOpen, setIsGenerateCollectionModalOpen] =
    useState(false);
  const [isEditImageModalOpen, setIsEditImageModalOpen] = useState(false);
  const [isCreateImageModalOpen, setIsCreateImageModalOpen] = useState(false);
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [isOpenCropModal, setIsOpenCropModal] = useState(false);
  const [isUserGalleryModalOpen, setIsUserGalleryModalOpen] = useState(false);
  const [isGeneratingFromGallery, setIsGeneratingFromGallery] = useState(false);
  const [galleryTarget, setGalleryTarget] = useState(GALLERY_TARGET.PRIMARY);
  const [cropTarget, setCropTarget] = useState(GALLERY_TARGET.PRIMARY);

  const [uploadedImage2, setUploadedImage2] = useState(null);
  const [uploadedImage3, setUploadedImage3] = useState(null);

  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const tooltipRef = useRef(null);
  const mainVideoRef = useRef(null);

  const isDesktop = useMediaQuery({ maxWidth: 1224 });
  const isTable = useMediaQuery({ maxWidth: 950 });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [aspectRatio, setAspectRatio] = useState(0.7293447293447294);
  const [isMainMediaLoaded, setIsMainMediaLoaded] = useState(false);

  const numOfColumns = useMemo(() => {
    if (isMobile) return 2;
    if (isTable) return 3;
    if (isDesktop) return 4;
    return 5;
  }, [isDesktop, isTable, isMobile]);

  const generateRandomSeed = () => {
    return Math.floor(Math.random() * 10000000) + 1;
  };

  const getChangeAnglePrompt = () => {
    const horizontalLabel = HORIZONTAL_ROTATION_OPTIONS.find(
      (opt) => opt.id === horizontalRotation,
    )?.label;
    const verticalLabel = VERTICAL_ANGLE_OPTIONS.find(
      (opt) => opt.id === verticalAngle,
    )?.label;
    const distanceLabel = DISTANCE_OPTIONS.find(
      (opt) => opt.id === distance,
    )?.label;

    return `${horizontalLabel} ${verticalLabel} ${distanceLabel}`.toLowerCase();
  };

  // ===== Computed prices =====
  const collectionPrice = useMemo(() => {
    if (!data) return 0;

    if (isVideoModel) {
      if (generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO) {
        return (
          (data.price ?? 0) +
          (nudifyEnabled ? NUDIFY_PRICE : 0) +
          (upscaleEnabled ? UPSCALE_PRICE : 0) +
          (audioEnabled ? AUDIO_PRICE : 0) +
          (VIDEO_RESOLUTION_PRICE?.[videoResolution] ?? 0) +
          (VIDEO_DURATION_PRICE?.[videoDuration] ?? 0) +
          (VIDEO_FPS_PRICE?.[fps] ?? 0)
        );
      }
      // Extend video
      return (
        (data.price ?? 0) +
        (audioEnabled ? AUDIO_PRICE : 0) +
        (VIDEO_RESOLUTION_PRICE?.[videoResolution] ?? 0) +
        (VIDEO_DURATION_PRICE?.[videoDuration] ?? 0) +
        (VIDEO_FPS_PRICE?.[fps] ?? 0)
      );
    }

    // Image model
    return (
      (data.price ?? 0) +
      (nudifyEnabled ? NUDIFY_PRICE : 0) +
      (upscaleEnabled ? UPSCALE_PRICE : 0) +
      (hasPromptInput && shouldEnhancePrompt ? 5 : 0)
    );
  }, [
    data,
    isVideoModel,
    nudifyEnabled,
    upscaleEnabled,
    generationTab,
    videoResolution,
    videoDuration,
    fps,
    audioEnabled,
    hasPromptInput,
    shouldEnhancePrompt,
  ]);

  const userGallerySelectedImages = useMemo(() => {
    return !isDoubleInputImageModel &&
      !isTripleInputImageModel &&
      uploadedImage?.url
      ? [uploadedImage.url]
      : [];
  }, [isDoubleInputImageModel, isTripleInputImageModel, uploadedImage?.url]);

  // Reset tab to Details when collection changes
  useEffect(() => {
    setActiveTab(PAGE_TABS[0].name);
    setAspectRatio(0.7293447293447294);
  }, [id]);

  useEffect(() => {
    const width = data?.input?.image?.resizedImage?.width;
    const height = data?.input?.image?.resizedImage?.height;
    if (width && height) {
      setAspectRatio(width / height);
    }
  }, [data]);

  useEffect(() => {
    setIsMainMediaLoaded(false);
  }, [displayOutputVideo, displayOutputImage, displayImage, isOutputImage]);

  // ===== Auto play/pause main video =====
  useEffect(() => {
    if (mainVideoRef.current) {
      if (autoPlay) {
        mainVideoRef.current.play().catch(() => {});
      } else {
        mainVideoRef.current.pause();
      }
    }
  }, [autoPlay]);

  // ===== Initialize nudify from collection data =====
  useEffect(() => {
    if (data?.nudify) {
      setNudifyEnabled(true);
    }
  }, [data]);

  useEffect(() => {
    setUpscaleEnabled(Boolean(data?.upscale));
  }, [data]);

  // Reset uploaded file when switching generation tabs
  useEffect(() => {
    setUploadedImage(null);
  }, [generationTab]);

  // ===== Fetch collection on mount =====
  useEffect(() => {
    if (id) {
      dispatch(fetchCollection({ collectionId: id }));
    }
  }, [dispatch, id]);

  // ===== Fetch on tab change =====
  useEffect(() => {
    if (!id || activeTab !== "Same Author" || !data?.user) return;

    const fetchSameAuthor = async () => {
      setSameAuthorData((prev) => ({ ...prev, loading: true, page: 1 }));

      try {
        const result = await dispatch(
          getSameAuthorCollections({ userId: data?.user }),
        ).unwrap();

        setSameAuthorData({
          data: result.data?.collections ?? [],
          total: result.data?.collections?.length ?? 0,
          loading: false,
          page: 1,
        });
      } catch (err) {
        console.error("fetchSameAuthor failed:", err);
        setSameAuthorData({ data: [], total: 0, loading: false, page: 1 });
      }
    };

    fetchSameAuthor();
  }, [activeTab, id, dispatch, data]);

  // ===== Close tooltip on outside click =====
  useEffect(() => {
    if (!showTooltip) return;

    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showTooltip]);

  // ===== Handlers =====
  const handleBack = () => {
    navigate(-1);
  };

  const handleShare = () => {
    if (!loggedIn) {
      dispatch(setSignUpModalOpen(true));
      return;
    }

    const shareUrl = `Check out "${
      data?.name ? formatModelName(data.name) : ""
    }" on Playbun - NSFW AI Video Generator! https://playbun.com/template/${id}?ref=${user.username}`;

    navigator.clipboard.writeText(shareUrl);

    toast.success(
      <ToastWrapper>
        <div>Copied! Share the referral link and get credits 🎉</div>

        <CopyContainer
          onClick={() => {
            navigator.clipboard.writeText(shareUrl);
            toast.success("Copied to clipboard!");
          }}
        >
          {shareUrl}
        </CopyContainer>
      </ToastWrapper>,
      {
        icon: null,
      },
    );
  };

  const handleUploadClick = () => {
    openUserGallery(GALLERY_TARGET.PRIMARY);
  };

  const handleImageUpload = async (file, setter) => {
    if (
      ![
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/heic",
        "image/heif",
      ].includes(file.type)
    ) {
      toast.error("Unsupported media type.");
      return;
    }

    if (file.size > MAX_IMAGE_SIZE) {
      toast.error("Image must be smaller than 30MB");
      return;
    }

    let processedFile = file;
    let blobToShow = file;

    if (file.type === "image/heic" || file.type === "image/heif") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpg",
          quality: 0.9,
        });

        blobToShow = convertedBlob;
        processedFile = new File(
          [convertedBlob],
          file.name.replace(/\.[^/.]+$/, ".jpg"),
          {
            type: "image/jpg",
            lastModified: Date.now(),
          },
        );
      } catch (error) {
        console.error("HEIC -> jpg conversion failed", error);
        toast.error("Failed to process HEIC image");
        return;
      }
    }

    setter({ file: processedFile, url: URL.createObjectURL(blobToShow) });
  };

  const handleVideoUpload = (file) => {
    if (
      !(file.type === "video/mp4" || file.type.startsWith("video/quicktime"))
    ) {
      toast.error("Unsupported media type.");
      return;
    }

    if (file.size > MAX_VIDEO_SIZE) {
      toast.error("Video must be smaller than 30MB");
      return;
    }

    setUploadedImage({ file, url: URL.createObjectURL(file) });
  };

  const handleFileChange = async (e, target = GALLERY_TARGET.PRIMARY) => {
    let file = e.target.files?.[0];

    if (!file) {
      e.target.value = "";
      return;
    }

    const shouldHandleAsVideo =
      target === GALLERY_TARGET.PRIMARY &&
      isVideoModel &&
      generationTab === MODAL_CONTENT.EXTEND_VIDEO;

    if (shouldHandleAsVideo) {
      handleVideoUpload(file);
    } else {
      await handleImageUpload(
        file,
        target === GALLERY_TARGET.TERTIARY
          ? setUploadedImage3
          : target === GALLERY_TARGET.SECONDARY
            ? setUploadedImage2
            : setUploadedImage,
      );
    }

    e.target.value = "";
  };

  const openUserGallery = (target = GALLERY_TARGET.PRIMARY) => {
    setGalleryTarget(target);
    setIsUserGalleryModalOpen(true);
  };

  const createGalleryMediaData = (mediaItem) => ({
    file: null,
    url: mediaItem.url,
    sourceUrl: mediaItem.url,
    type: mediaItem.type,
  });

  const prepareImageForCrop = async (image, target) => {
    if (image?.file || !image?.sourceUrl || image?.url?.startsWith("blob:")) {
      return image;
    }

    try {
      const response = await fetch(image.sourceUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Failed to load gallery image");

      const blob = await response.blob();
      const preparedImage = {
        ...image,
        url: URL.createObjectURL(blob),
      };

      if (target === GALLERY_TARGET.TERTIARY) {
        setUploadedImage3(preparedImage);
      } else if (target === GALLERY_TARGET.SECONDARY) {
        setUploadedImage2(preparedImage);
      } else {
        setUploadedImage(preparedImage);
      }

      return preparedImage;
    } catch (error) {
      console.error("Failed to prepare gallery image for crop", error);
      return image;
    }
  };

  const openCropModalForTarget = async (target = GALLERY_TARGET.PRIMARY) => {
    const image =
      target === GALLERY_TARGET.TERTIARY
        ? uploadedImage3
        : target === GALLERY_TARGET.SECONDARY
          ? uploadedImage2
          : uploadedImage;
    if (!image) return;

    await prepareImageForCrop(image, target);
    setCropTarget(target);
    setIsOpenCropModal(true);
  };

  const handleUserGalleryConfirm = async (mediaItems) => {
    const [selectedMediaItem] = mediaItems;

    if (!selectedMediaItem) {
      return false;
    }

    const mediaData = createGalleryMediaData(selectedMediaItem);

    if (galleryTarget === GALLERY_TARGET.TERTIARY) {
      setUploadedImage3(mediaData);
    } else if (galleryTarget === GALLERY_TARGET.SECONDARY) {
      setUploadedImage2(mediaData);
    } else {
      setUploadedImage(mediaData);
    }

    return true;
  };

  const handleGenerateFromGallery = async (mediaItems) => {
    if (!mediaItems.length) {
      return false;
    }

    if (!isVideoModel) {
      if (isBodywritingModel) {
        if (!bodyWritingText || !bodyWritingText.trim()) {
          toast.error("Body writing text is required");
          return false;
        }
      } else if (isEditImageModel && data?.name === "Edit Image") {
        if (!customPrompt || customPrompt.length === 0) {
          toast.error("Please add prompt");
          return false;
        }
      }
    }

    try {
      setIsGeneratingFromGallery(true);
      let successfulGenerations = 0;
      let firstSuccessfulMediaUrl = null;

      for (const [index, mediaItem] of mediaItems.entries()) {
        if (!isVideoModel && mediaItem.type === "video") {
          console.error("Gallery generation failed", {
            message: "Video input is not supported for image generation",
            mediaItem,
          });

          if (index < mediaItems.length - 1) {
            await pause(300);
          }

          continue;
        }

        if (isVideoModel) {
          try {
            await dispatch(
              generateCollection({
                ...(mediaItem.type === "video"
                  ? { videoUrl: mediaItem.url }
                  : { imageUrl: mediaItem.url }),
                customPrompt,
                negativePrompt,
                nudify: nudifyEnabled,
                upscale: upscaleEnabled,
                audio: audioEnabled,
                modelId: data.model,
                resolution: videoResolution,
                seed: seedNumber,
                fps,
                videoDuration,
              }),
            ).unwrap();

            successfulGenerations += 1;

            if (!firstSuccessfulMediaUrl) {
              firstSuccessfulMediaUrl = mediaItem.url;
            }
          } catch (error) {
            console.error("Gallery generation failed", error);
          }
        } else {
          const formData = new FormData();
          formData.append("collectionId", data._id);
          formData.append("nudify", nudifyEnabled);
          formData.append("upscale", upscaleEnabled);
          formData.append("modelId", data.model);

          if (bodyWritingText?.trim()) {
            formData.append("text", bodyWritingText.trim());
          }
          if (where) {
            formData.append("placement", where);
          }
          if (writingStyle) {
            formData.append("writingStyle", writingStyle);
          }
          if (nakedStyle) {
            formData.append("style", nakedStyle);
          }
          if (customPrompt?.trim()) {
            formData.append("customPrompt", customPrompt.trim());
          }
          if (isChangeAngleModel) {
            formData.set("customPrompt", getChangeAnglePrompt());
          }
          formData.append("seed", seedNumber || generateRandomSeed());
          formData.append("imageUrl", mediaItem.url);

          try {
            await dispatch(generateImageCollection(formData)).unwrap();
            successfulGenerations += 1;

            if (!firstSuccessfulMediaUrl) {
              firstSuccessfulMediaUrl = mediaItem.url;
            }
          } catch (error) {
            console.error("Gallery generation failed", error);
          }
        }

        if (index < mediaItems.length - 1) {
          await pause(300);
        }
      }

      if (!successfulGenerations) {
        throw new Error("Failed to start generation");
      }

      if (successfulGenerations !== mediaItems.length) {
        toast.error("Failed to start one or more generations");
      }

      setIsExploding(true);
      setTimeout(() => {
        setIsExploding(false);
      }, 600);

      toast.custom(() => (
        <GenerationToast
          successMessage={
            successfulGenerations === 1
              ? generationTab === MODAL_CONTENT.EXTEND_VIDEO && isVideoModel
                ? "Extending started.."
                : "Generation started..."
              : `${successfulGenerations} generations started...`
          }
          label="View"
          onClick={() => {
            navigate("/collection");

            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "instant",
            });
          }}
        />
      ));

      resetGenerationState();
      return true;
    } catch (error) {
      toast.error(
        error?.message ||
          "An error occurred while generating. Please try again later.",
      );
      return false;
    } finally {
      setIsGeneratingFromGallery(false);
    }
  };

  const getGalleryAllowedMediaTypes = () => {
    if (
      galleryTarget === GALLERY_TARGET.SECONDARY ||
      galleryTarget === GALLERY_TARGET.TERTIARY
    ) {
      return ["image"];
    }

    if (isVideoModel && generationTab === MODAL_CONTENT.EXTEND_VIDEO) {
      return ["video"];
    }

    if (
      isImageModel ||
      isBlendModel ||
      isDoubleInputImageModel ||
      isTripleInputImageModel
    ) {
      return ["image"];
    }

    return ["image", "video"];
  };

  const shouldGenerateFromGallery =
    !isDoubleInputImageModel && !isTripleInputImageModel && !isBlendModel;
  const galleryConfirmLabel =
    shouldGenerateFromGallery &&
    generationTab === MODAL_CONTENT.EXTEND_VIDEO &&
    isVideoModel
      ? "Extend"
      : shouldGenerateFromGallery
        ? "Generate"
        : "Select";

  const openGallerySettings = () => {
    if (isVideoModel) {
      setIsEnterPromptModalOpen(true);
      localStorage.setItem("wasPromptModalOpen", true);
      return;
    }

    setIsOpenCustomizePromptModalOpen(true);
  };

  const renderOpenGalleryButton = (target = GALLERY_TARGET.PRIMARY) => (
    <UploadGalleryButton
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        openUserGallery(target);
      }}
    >
      Open Gallery
    </UploadGalleryButton>
  );

  const resetGenerationState = () => {
    setUploadedImage(null);
    setUploadedImage2(null);
    setUploadedImage3(null);
    setNudifyEnabled(false);
    setUpscaleEnabled(false);
    setCustomPrompt("");
    setNegativePrompt("");
    setAudioPrompt("");
    setBodyWritingText("");
    setWhere("face");
    setWritingStyle("realistic");
    setNakedStyle("natural");
    setHorizontalRotation(DEFAULT_HORIZONTAL_ROTATION);
    setVerticalAngle(DEFAULT_VERTICAL_ANGLE);
    setDistance(DEFAULT_DISTANCE);
    setSeedNumber(Math.floor(Math.random() * 10000000) + 1);
    setShowPrompts(false);
    setShouldEnhancePrompt(false);
  };

  const getBlendImagePayload = (image, index) => {
    if (image?.file) {
      return index === 2 ? { image2: image.file } : { image: image.file };
    }

    const imageUrl = image?.sourceUrl || image?.url;

    return index === 2 ? { imageUrl2: imageUrl } : { imageUrl };
  };

  const getCollectionImagePayload = (image, index = 1) => {
    if (image?.file) {
      return index === 2 ? { image2: image } : { image };
    }

    const imageUrl = image?.sourceUrl || image?.url;

    return index === 2 ? { imageUrl2: imageUrl } : { imageUrl };
  };

  const getCollectionVideoPayload = (video) => {
    if (video?.file) {
      return { video };
    }

    return { videoUrl: video?.sourceUrl || video?.url };
  };

  const appendImageInput = (formData, image, index = 1) => {
    const fileFieldName =
      index === 3 ? "image3" : index === 2 ? "image2" : "image";
    const urlFieldName =
      index === 3 ? "image3Url" : index === 2 ? "image2Url" : "imageUrl";

    if (image?.file) {
      formData.append(fileFieldName, image.file);
      return;
    }

    const imageUrl = image?.sourceUrl || image?.url;
    if (imageUrl) {
      formData.append(urlFieldName, imageUrl);
    }
  };

  const handleGenerate = () => {
    if (!loggedIn) {
      dispatch(setSignUpModalOpen(true));
      return;
    }
    if (generateLoading || !data) return;

    if (isVideoModel) {
      // ===== Video generation =====
      if (isBlendModel) {
        if (!uploadedImage || !uploadedImage2) {
          toast.error("Please add both input images");
          return;
        }
      }

      if (isBlendModel) {
        dispatch(
          generateBlendCollection({
            ...getBlendImagePayload(uploadedImage, 1),
            ...getBlendImagePayload(uploadedImage2, 2),
            customPrompt,
            negativePrompt,
            upscale: upscaleEnabled,
            modelId: data.model,
            resolution: videoResolution,
            seed: seedNumber,
            fps,
            videoDuration,
          }),
        )
          .unwrap()
          .then(() => {
            setIsExploding(true);

            setTimeout(() => {
              setIsExploding(false);
            }, 600);

            toast.custom(() => (
              <GenerationToast
                label="View"
                onClick={() => {
                  navigate("/collection");

                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }}
              />
            ));
            resetGenerationState();
          })
          .catch((err) => {
            toast.error(err);
          });
      } else if (generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO) {
        dispatch(
          generateCollection({
            ...getCollectionImagePayload(uploadedImage),
            customPrompt,
            negativePrompt,
            nudify: nudifyEnabled,
            upscale: upscaleEnabled,
            audio: audioEnabled,
            modelId: data.model,
            resolution: videoResolution,
            seed: seedNumber,
            fps,
            videoDuration,
          }),
        )
          .unwrap()
          .then(() => {
            setIsExploding(true);

            setTimeout(() => {
              setIsExploding(false);
            }, 600);

            toast.custom(() => (
              <GenerationToast
                label="View"
                onClick={() => {
                  navigate("/collection");

                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }}
              />
            ));
            resetGenerationState();
          })
          .catch((err) => {
            toast.error(err);
          });
      } else {
        // EXTEND_VIDEO
        dispatch(
          generateCollection({
            ...getCollectionVideoPayload(uploadedImage),
            customPrompt,
            negativePrompt,
            audio: audioEnabled,
            modelId: data.model,
            resolution: videoResolution,
            seed: seedNumber,
            fps,
            videoDuration,
          }),
        )
          .unwrap()
          .then(() => {
            setIsExploding(true);

            setTimeout(() => {
              setIsExploding(false);
            }, 600);

            toast.custom(() => (
              <GenerationToast
                successMessage={"Extending started.."}
                label="View"
                onClick={() => {
                  navigate("/collection");

                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }}
              />
            ));

            resetGenerationState();
          })
          .catch((err) => {
            toast.error(err);
          });
      }
    } else {
      // ===== Image generation =====
      // Validation
      if (isBodywritingModel) {
        if (!bodyWritingText || !bodyWritingText.trim()) {
          toast.error("Body writing text is required");
          return;
        }
      } else if (isEditImageModel && data?.name === "Edit Image") {
        if (!customPrompt || customPrompt.length === 0) {
          toast.error("Please add prompt");
          return;
        }
      } else if (isDoubleInputImageModel) {
        if (!uploadedImage || !uploadedImage2) {
          toast.error("Please add input images");
          return;
        }
      } else if (isTripleInputImageModel) {
        if (!uploadedImage || !uploadedImage2 || !uploadedImage3) {
          toast.error("Please add input images");
          return;
        }
      }

      const formData = new FormData();
      formData.append("collectionId", data._id);
      formData.append("nudify", nudifyEnabled);
      formData.append("upscale", upscaleEnabled);
      formData.append("shouldEnhancePrompt", shouldEnhancePrompt);
      formData.append("modelId", data.model);

      if (bodyWritingText?.trim()) {
        formData.append("text", bodyWritingText.trim());
      }
      if (where) {
        formData.append("placement", where);
      }
      if (writingStyle) {
        formData.append("writingStyle", writingStyle);
      }
      if (nakedStyle) {
        formData.append("style", nakedStyle);
      }
      if (customPrompt?.trim()) {
        formData.append("customPrompt", customPrompt.trim());
      }
      if (isChangeAngleModel) {
        formData.set("customPrompt", getChangeAnglePrompt());
      }
      formData.append("seed", seedNumber || generateRandomSeed());

      appendImageInput(formData, uploadedImage);
      appendImageInput(formData, uploadedImage2, 2);
      appendImageInput(formData, uploadedImage3, 3);

      dispatch(generateImageCollection(formData))
        .unwrap()
        .then(() => {
          setIsExploding(true);

          setTimeout(() => {
            setIsExploding(false);
          }, 600);
          toast.custom(() => (
            <GenerationToast
              label="View"
              onClick={() => {
                navigate("/collection");

                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "instant",
                });
              }}
            />
          ));
          resetGenerationState();
        })
        .catch((err) => {
          toast.error(
            err ??
              "An error occurred while generating. Please try again later.",
          );
        });
    }
  };

  const videoTooltipContent =
    generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO
      ? [
          "The uploaded image will be used as the first frame of the generated video.",
          "For best results, match the original image. The AI follows basic physics - objects not in the input image are unlikely to appear in the generated video.",
        ]
      : [
          "Extending a video reuses its last frame as the starting point for the new generation, making the final video longer and seamless.",
        ];

  // =============================================
  // Video Generation Section
  // =============================================
  const renderVideoGeneration = () => (
    <GenerationSection>
      <GenerationTitle>
        {isBlendModel ? "Generate Video" : "Create or Extend Video"}
      </GenerationTitle>

      {!isBlendModel && (
        <GenerationTabsContainer $activeTab={generationTab}>
          <GenerationTab
            onClick={() => setGenerationTab(MODAL_CONTENT.IMAGE_TO_VIDEO)}
          >
            <ImageIcon
              width={16}
              height={16}
              color={
                generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO ? "#000" : "#fff"
              }
            />
            <GenerationTabText
              $selected={generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO}
            >
              Image to Video
            </GenerationTabText>
          </GenerationTab>
          <GenerationTab
            onClick={() => setGenerationTab(MODAL_CONTENT.EXTEND_VIDEO)}
          >
            <VideoRecorderIcon
              width={16}
              height={16}
              color={
                generationTab === MODAL_CONTENT.EXTEND_VIDEO ? "#000" : "#fff"
              }
            />
            <GenerationTabText
              $selected={generationTab === MODAL_CONTENT.EXTEND_VIDEO}
            >
              Extend Video
            </GenerationTabText>
          </GenerationTab>
        </GenerationTabsContainer>
      )}

      <input
        ref={fileInputRef}
        type="file"
        accept={
          isBlendModel || generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO
            ? "image/*"
            : "video/*"
        }
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      {isBlendModel ? (
        <>
          <UploadArea
            onClick={() => openUserGallery(GALLERY_TARGET.PRIMARY)}
            style={{ minHeight: 150 }}
          >
            {uploadedImage ? (
              <>
                <PreviewDeleteButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setUploadedImage(null);
                  }}
                >
                  <LottieIcon
                    animationData={deleteAnimation}
                    trigger="hover"
                    size={24}
                  />
                </PreviewDeleteButton>
                <PreviewCropButton
                  onClick={(e) => {
                    e.stopPropagation();
                    openCropModalForTarget(GALLERY_TARGET.PRIMARY);
                  }}
                >
                  <CropIcon />
                </PreviewCropButton>
                <UploadedPreview src={uploadedImage.url} alt="Image 1" />
              </>
            ) : (
              <>
                <UploadIcon>
                  <UploadCloudIcon width={24} height={24} />
                </UploadIcon>
                <UploadText>Select Image 1</UploadText>
                {renderOpenGalleryButton(GALLERY_TARGET.PRIMARY)}
              </>
            )}
          </UploadArea>
          <input
            ref={fileInputRef2}
            type="file"
            accept="image/jpeg,image/png,image/jpg,image/webp,image/heic,image/heif"
            onChange={(e) => handleFileChange(e, GALLERY_TARGET.SECONDARY)}
            style={{ display: "none" }}
          />
          <UploadArea
            onClick={() => openUserGallery(GALLERY_TARGET.SECONDARY)}
            style={{ minHeight: 150 }}
          >
            {uploadedImage2 ? (
              <>
                <PreviewDeleteButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setUploadedImage2(null);
                  }}
                >
                  <LottieIcon
                    animationData={deleteAnimation}
                    trigger="hover"
                    size={24}
                  />
                </PreviewDeleteButton>
                <PreviewCropButton
                  onClick={(e) => {
                    e.stopPropagation();
                    openCropModalForTarget(GALLERY_TARGET.SECONDARY);
                  }}
                >
                  <CropIcon />
                </PreviewCropButton>
                <UploadedPreview src={uploadedImage2.url} alt="Image 2" />
              </>
            ) : (
              <>
                <UploadIcon>
                  <UploadCloudIcon width={24} height={24} />
                </UploadIcon>
                <UploadText>Select Image 2</UploadText>
                {renderOpenGalleryButton(GALLERY_TARGET.SECONDARY)}
              </>
            )}
          </UploadArea>
        </>
      ) : (
        <UploadArea onClick={handleUploadClick}>
          {uploadedImage ? (
            generationTab === MODAL_CONTENT.EXTEND_VIDEO ? (
              <>
                <PreviewDeleteButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setUploadedImage(null);
                  }}
                >
                  <LottieIcon
                    animationData={deleteAnimation}
                    trigger="hover"
                    size={24}
                  />
                </PreviewDeleteButton>

                <UploadedVideoPreview
                  src={uploadedImage.url}
                  loop
                  muted
                  autoPlay
                  playsInline
                />
              </>
            ) : (
              <>
                <PreviewDeleteButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setUploadedImage(null);
                  }}
                >
                  <LottieIcon
                    animationData={deleteAnimation}
                    trigger="hover"
                    size={24}
                  />
                </PreviewDeleteButton>
                <PreviewCropButton
                  onClick={(e) => {
                    e.stopPropagation();
                    openCropModalForTarget(GALLERY_TARGET.PRIMARY);
                  }}
                >
                  <CropIcon />
                </PreviewCropButton>
                <UploadedPreview
                  src={uploadedImage.url}
                  alt="Uploaded preview"
                />
              </>
            )
          ) : (
            <>
              <UploadIcon>
                <UploadCloudIcon width={24} height={24} />
              </UploadIcon>
              <UploadText>
                {generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO
                  ? "Select Image to generate"
                  : "Select Video to generate"}
              </UploadText>
              {renderOpenGalleryButton()}
            </>
          )}
        </UploadArea>
      )}

      {(isBlendModel || generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO) && (
        <CheckboxGroup>
          {!isBlendModel && (
            <CheckboxRow onClick={() => setNudifyEnabled(!nudifyEnabled)}>
              <LottieIcon
                animationData={checkboxAnimation}
                trigger="toggle-reverse"
                isActive={nudifyEnabled}
                speed={2}
                onActiveChange={() => setNudifyEnabled(!nudifyEnabled)}
                onClick={() => setNudifyEnabled(!nudifyEnabled)}
                size={24}
                strokeColor={"#2877d9"}
              />
              <CheckboxLabel>Nudify First</CheckboxLabel>
            </CheckboxRow>
          )}
          <CheckboxRow onClick={() => setUpscaleEnabled(!upscaleEnabled)}>
            <LottieIcon
              animationData={checkboxAnimation}
              trigger="toggle-reverse"
              isActive={upscaleEnabled}
              speed={2}
              onActiveChange={() => setUpscaleEnabled(!upscaleEnabled)}
              onClick={() => setUpscaleEnabled(!upscaleEnabled)}
              size={24}
              strokeColor={"#2877d9"}
            />
            <CheckboxLabel>Enhance Photo</CheckboxLabel>
          </CheckboxRow>
        </CheckboxGroup>
      )}

      <GenerateRow>
        <SettingsIconWrapper
          onClick={() => {
            setIsEnterPromptModalOpen(true);
            localStorage.setItem("wasPromptModalOpen", true);
          }}
        >
          <LottieIcon
            animationData={settingsAnimation}
            trigger="hover"
            strokeColor={"#fff"}
            size={28}
          />
        </SettingsIconWrapper>

        <ExplosionButton
          disabled={generateLoading}
          onClick={handleGenerate}
          isLoading={generateLoading}
          isExploding={isExploding}
          style={{ flex: 1 }}
        >
          {generateLoading ? (
            <l-line-spinner size="16" stroke="1.25" speed="1.5" color="black" />
          ) : (
            <>
              {generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO
                ? "Generate"
                : "Extend"}
              <GradientStarIcon />
              <CreditBadge>{Math.ceil(collectionPrice)}</CreditBadge>
            </>
          )}
        </ExplosionButton>

        <InfoIconButton
          ref={tooltipRef}
          onMouseEnter={() => {
            if (!isMobile) setShowTooltip(true);
          }}
          onMouseLeave={() => {
            if (!isMobile) setShowTooltip(false);
          }}
          onClick={() => {
            if (isMobile) setShowTooltip(!showTooltip);
          }}
        >
          <InfoIcon width={18} height={18} />
          {showTooltip && (
            <TooltipContainer>
              {videoTooltipContent.map((text, i) => (
                <TooltipText key={i}>{text}</TooltipText>
              ))}
              {data?.description && data.description !== "" && (
                <>
                  <TooltipText $light>Tips</TooltipText>
                  <TooltipText>{data.description}</TooltipText>
                </>
              )}
            </TooltipContainer>
          )}
        </InfoIconButton>
      </GenerateRow>
    </GenerationSection>
  );

  // =============================================
  // Image Generation Section
  // =============================================
  const renderImageGeneration = () => (
    <GenerationSection>
      <GenerationTitle>Generate Image</GenerationTitle>

      {/* Upload */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/png,image/jpg,image/webp,image/heic,image/heif"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      {isDoubleInputImageModel || isTripleInputImageModel ? (
        <>
          <UploadArea
            onClick={() => openUserGallery(GALLERY_TARGET.PRIMARY)}
            style={{ minHeight: 150 }}
          >
            {uploadedImage ? (
              <>
                <PreviewDeleteButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setUploadedImage(null);
                  }}
                >
                  <LottieIcon
                    animationData={deleteAnimation}
                    trigger="hover"
                    size={24}
                  />
                </PreviewDeleteButton>
                <PreviewCropButton
                  onClick={(e) => {
                    e.stopPropagation();
                    openCropModalForTarget(GALLERY_TARGET.PRIMARY);
                  }}
                >
                  <CropIcon />
                </PreviewCropButton>
                <UploadedPreview src={uploadedImage.url} alt="Image 1" />
              </>
            ) : (
              <>
                <UploadIcon>
                  <UploadCloudIcon width={24} height={24} />
                </UploadIcon>
                <UploadText>Select Image 1</UploadText>
                {renderOpenGalleryButton(GALLERY_TARGET.PRIMARY)}
              </>
            )}
          </UploadArea>
          <input
            ref={fileInputRef2}
            type="file"
            accept="image/jpeg,image/png,image/jpg,image/webp,image/heic,image/heif"
            onChange={(e) => handleFileChange(e, GALLERY_TARGET.SECONDARY)}
            style={{ display: "none" }}
          />
          <UploadArea
            onClick={() => openUserGallery(GALLERY_TARGET.SECONDARY)}
            style={{ minHeight: 150 }}
          >
            {uploadedImage2 ? (
              <>
                <PreviewDeleteButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setUploadedImage2(null);
                  }}
                >
                  <LottieIcon
                    animationData={deleteAnimation}
                    trigger="hover"
                    size={24}
                  />
                </PreviewDeleteButton>
                <PreviewCropButton
                  onClick={(e) => {
                    e.stopPropagation();
                    openCropModalForTarget(GALLERY_TARGET.SECONDARY);
                  }}
                >
                  <CropIcon />
                </PreviewCropButton>
                <UploadedPreview src={uploadedImage2.url} alt="Image 2" />
              </>
            ) : (
              <>
                <UploadIcon>
                  <UploadCloudIcon width={24} height={24} />
                </UploadIcon>
                <UploadText>Select Image 2</UploadText>
                {renderOpenGalleryButton(GALLERY_TARGET.SECONDARY)}
              </>
            )}
          </UploadArea>
          {isTripleInputImageModel && (
            <>
              <input
                ref={fileInputRef3}
                type="file"
                accept="image/jpeg,image/png,image/jpg,image/webp,image/heic,image/heif"
                onChange={(e) => handleFileChange(e, GALLERY_TARGET.TERTIARY)}
                style={{ display: "none" }}
              />
              <UploadArea
                onClick={() => openUserGallery(GALLERY_TARGET.TERTIARY)}
                style={{ minHeight: 150 }}
              >
                {uploadedImage3 ? (
                  <>
                    <PreviewDeleteButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setUploadedImage3(null);
                      }}
                    >
                      <LottieIcon
                        animationData={deleteAnimation}
                        trigger="hover"
                        size={24}
                      />
                    </PreviewDeleteButton>
                    <PreviewCropButton
                      onClick={(e) => {
                        e.stopPropagation();
                        openCropModalForTarget(GALLERY_TARGET.TERTIARY);
                      }}
                    >
                      <CropIcon />
                    </PreviewCropButton>
                    <UploadedPreview src={uploadedImage3.url} alt="Image 3" />
                  </>
                ) : (
                  <>
                    <UploadIcon>
                      <UploadCloudIcon width={24} height={24} />
                    </UploadIcon>
                    <UploadText>Select Image 3</UploadText>
                    {renderOpenGalleryButton(GALLERY_TARGET.TERTIARY)}
                  </>
                )}
              </UploadArea>
            </>
          )}
        </>
      ) : (
        <UploadArea onClick={!uploadedImage ? handleUploadClick : undefined}>
          {uploadedImage ? (
            <>
              <PreviewDeleteButton
                onClick={(e) => {
                  e.stopPropagation();
                  setUploadedImage(null);
                }}
              >
                <LottieIcon
                  animationData={deleteAnimation}
                  trigger="hover"
                  size={24}
                />
              </PreviewDeleteButton>
              <PreviewCropButton
                onClick={(e) => {
                  e.stopPropagation();
                  openCropModalForTarget(GALLERY_TARGET.PRIMARY);
                }}
              >
                <CropIcon />
              </PreviewCropButton>
              <UploadedPreview src={uploadedImage.url} alt="Uploaded preview" />
            </>
          ) : (
            <>
              <UploadIcon>
                <UploadCloudIcon width={24} height={24} />
              </UploadIcon>
              <UploadText>Select Image to generate</UploadText>
              {renderOpenGalleryButton()}
            </>
          )}
        </UploadArea>
      )}

      {/* Model-specific options */}
      {!isBodywritingModel &&
        !isUpscaleModel &&
        !isDoubleInputImageModel &&
        !isTripleInputImageModel &&
        !isChangeAngleModel && (
          <SettingsContainer>
            <NudifyContainer onClick={() => setUpscaleEnabled(!upscaleEnabled)}>
              <LottieIcon
                animationData={checkboxAnimation}
                speed={2}
                trigger="toggle-reverse"
                isActive={upscaleEnabled}
                onActiveChange={() => setUpscaleEnabled(!upscaleEnabled)}
                onClick={() => setUpscaleEnabled(!upscaleEnabled)}
                size={24}
                strokeColor={!upscaleEnabled ? "#2877d9" : "#ffffff"}
              />
              <NudifyText>Enhance photo before edit</NudifyText>
            </NudifyContainer>
          </SettingsContainer>
        )}

      {isGettingNakedModel && (
        <SettingsContainer>
          <SettingsColumn>
            <SettingsLabelText>Style</SettingsLabelText>
            <OptionCheckboxRow>
              {GETTING_NAKED_OPTIONS.map((option) => {
                const isChecked = nakedStyle === option.id;
                return (
                  <OptionCheckbox
                    $checked={isChecked}
                    key={option.id}
                    onClick={() => setNakedStyle(option.id)}
                  >
                    <LottieIcon
                      animationData={radioButtonAnimation}
                      speed={2}
                      trigger="toggle-reverse"
                      isActive={isChecked}
                      size={22}
                      strokeColor={!isChecked ? "#2877d9" : "#ffffff"}
                    />
                    <OptionCheckboxText>{option.label}</OptionCheckboxText>
                  </OptionCheckbox>
                );
              })}
            </OptionCheckboxRow>
          </SettingsColumn>
        </SettingsContainer>
      )}

      {isBodywritingModel && (
        <SettingsContainer>
          <NudifyContainer onClick={() => setUpscaleEnabled(!upscaleEnabled)}>
            <LottieIcon
              animationData={checkboxAnimation}
              speed={2}
              trigger="toggle-reverse"
              isActive={upscaleEnabled}
              onActiveChange={() => setUpscaleEnabled(!upscaleEnabled)}
              onClick={() => setUpscaleEnabled(!upscaleEnabled)}
              size={24}
              strokeColor={!upscaleEnabled ? "#2877d9" : "#ffffff"}
            />
            <NudifyText>Enhance photo before applying text</NudifyText>
          </NudifyContainer>

          <NudifyContainer onClick={() => setNudifyEnabled(!nudifyEnabled)}>
            <LottieIcon
              animationData={checkboxAnimation}
              speed={2}
              trigger="toggle-reverse"
              isActive={nudifyEnabled}
              onActiveChange={() => setNudifyEnabled(!nudifyEnabled)}
              onClick={() => setNudifyEnabled(!nudifyEnabled)}
              size={24}
              strokeColor={!nudifyEnabled ? "#2877d9" : "#ffffff"}
            />
            <NudifyText>Nudify before applying text</NudifyText>
          </NudifyContainer>

          <SettingsColumn>
            <SettingsLabelText>Text</SettingsLabelText>
            <SettingsInput
              type="text"
              placeholder="Enter the bodywriting text…"
              value={bodyWritingText}
              onChange={(e) => setBodyWritingText(e.target.value)}
            />
          </SettingsColumn>

          <SettingsColumn>
            <SettingsLabelText>Where?</SettingsLabelText>
            <OptionCheckboxContainer>
              {WHERE_OPTIONS.map((option) => {
                const isChecked = where === option.id;
                return (
                  <OptionCheckbox
                    key={option.id}
                    $checked={isChecked}
                    onClick={() => setWhere(option.id)}
                  >
                    <LottieIcon
                      animationData={radioButtonAnimation}
                      trigger="toggle-reverse"
                      speed={2}
                      isActive={isChecked}
                      size={22}
                      strokeColor={!isChecked ? "#2877d9" : "#ffffff"}
                    />
                    <OptionCheckboxText>{option.label}</OptionCheckboxText>
                  </OptionCheckbox>
                );
              })}
            </OptionCheckboxContainer>
          </SettingsColumn>

          <SettingsColumn>
            <SettingsLabelText>Writing Style</SettingsLabelText>
            <OptionCheckboxRow>
              {WRITING_STYLE_OPTIONS.map((option) => {
                const isChecked = writingStyle === option.id;
                return (
                  <OptionCheckbox
                    $checked={isChecked}
                    key={option.id}
                    onClick={() => setWritingStyle(option.id)}
                  >
                    <LottieIcon
                      animationData={radioButtonAnimation}
                      speed={2}
                      trigger="toggle-reverse"
                      isActive={isChecked}
                      size={22}
                      strokeColor={!isChecked ? "#2877d9" : "#ffffff"}
                    />
                    <OptionCheckboxText>{option.label}</OptionCheckboxText>
                  </OptionCheckbox>
                );
              })}
            </OptionCheckboxRow>
          </SettingsColumn>
        </SettingsContainer>
      )}

      {isChangeAngleModel ? (
        <AngleDropdownsContainer>
          <AngleDropdown
            value={horizontalRotation}
            options={HORIZONTAL_ROTATION_OPTIONS}
            onChange={setHorizontalRotation}
            disabled={generateLoading}
          />
          <AngleDropdown
            value={verticalAngle}
            options={VERTICAL_ANGLE_OPTIONS}
            onChange={setVerticalAngle}
            disabled={generateLoading}
          />
          <AngleDropdown
            value={distance}
            options={DISTANCE_OPTIONS}
            onChange={setDistance}
            disabled={generateLoading}
          />
        </AngleDropdownsContainer>
      ) : hasPromptInput ? (
        <SettingsContainer style={{ marginTop: -10 }}>
          <SettingsColumn>
            <NudifyContainer
              style={{ marginBottom: 5 }}
              onClick={() => setShouldEnhancePrompt(!shouldEnhancePrompt)}
            >
              <LottieIcon
                animationData={checkboxAnimation}
                trigger="toggle-reverse"
                isActive={shouldEnhancePrompt}
                speed={2}
                onActiveChange={() =>
                  setShouldEnhancePrompt(!shouldEnhancePrompt)
                }
                onClick={() => setShouldEnhancePrompt(!shouldEnhancePrompt)}
                size={24}
                strokeColor={"#2877d9"}
              />
              <NudifyText>Enhance prompt before generation</NudifyText>
            </NudifyContainer>
            <SettingsLabelText>Prompt</SettingsLabelText>
            <SettingsTextarea
              style={{
                minHeight: isDoubleInputImageModel ? 88 : 126,
              }}
              placeholder={
                isDoubleInputImageModel
                  ? "Woman hugs man"
                  : data?.customPrompt || "Enter the custom prompt here"
              }
              value={customPrompt}
              onChange={(e) => setCustomPrompt(e.target.value)}
            />
          </SettingsColumn>
        </SettingsContainer>
      ) : null}

      {/* Generate row */}
      <GenerateRow>
        {!isChangeAngleModel && (
          <SettingsIconWrapper
            onClick={() => setIsOpenCustomizePromptModalOpen(true)}
          >
            <LottieIcon
              animationData={settingsAnimation}
              trigger="hover"
              strokeColor={"#fff"}
              size={28}
            />
          </SettingsIconWrapper>
        )}

        <ExplosionButton
          disabled={generateLoading}
          onClick={handleGenerate}
          isLoading={generateLoading}
          isExploding={isExploding}
          style={{ flex: 1 }}
        >
          {generateLoading ? (
            <l-line-spinner size="16" stroke="1.25" speed="1.5" color="black" />
          ) : (
            <>
              Generate
              <CreditIcon width={14} height={14} />
              <CreditBadge>{Math.ceil(collectionPrice)}</CreditBadge>
            </>
          )}
        </ExplosionButton>
        <InfoIconButton
          onMouseEnter={() => {
            if (!isMobile) setShowTooltip(true);
          }}
          onMouseLeave={() => {
            if (!isMobile) setShowTooltip(false);
          }}
          onClick={() => {
            if (isMobile) setShowTooltip(!showTooltip);
          }}
        >
          <InfoIcon width={18} height={18} />
          {showTooltip && (
            <TooltipContainer ref={tooltipRef}>
              <TooltipText>
                Upload your image and the AI will generate the result based on
                the selected model and settings.
              </TooltipText>
              {data?.description && data.description !== "" && (
                <>
                  <TooltipText $light>Tips</TooltipText>
                  <TooltipText>{data.description}</TooltipText>
                </>
              )}
            </TooltipContainer>
          )}
        </InfoIconButton>
      </GenerateRow>
    </GenerationSection>
  );

  // ===== Masonry grid renderer =====
  const renderMasonryContent = (items, tabLoading) => {
    if (tabLoading) {
      return <VideoMasonrySkeletonLoader count={20} mobileTwoRows />;
    }

    if (!items || !items.length) {
      return (
        <EmptyState>
          <h3>Nothing found</h3>
          <p>There are no collections to display at the moment.</p>
        </EmptyState>
      );
    }

    return (
      <MasonryGrid>
        {Array.from({ length: numOfColumns }).map((_, colIndex) => (
          <MasonryColumn key={colIndex}>
            {items
              .filter((item) => {
                if (activeTab === "Extend With") {
                  return !isImageOutput(item.modelName);
                }
                return true;
              })
              .filter((_, i) => i % numOfColumns === colIndex)
              .map((item) => (
                <ExploreItem
                  key={item._id}
                  item={item}
                  onItemClick={() => {
                    if (loggedIn) {
                      dispatch(setSelectedCollection(item));
                      if (item.modelType === CREATE_IMAGE_MODEL_NAME) {
                        setIsCreateImageModalOpen(true);
                      } else if (item.modelType === BLEND_MODEL) {
                        setIsGroupModalOpen(true);
                      } else if (
                        isImageOutput(item.modelType ?? item.modelName)
                      ) {
                        setIsEditImageModalOpen(true);
                      } else {
                        setIsGenerateCollectionModalOpen(true);
                      }
                    } else {
                      dispatch(setSignUpModalOpen(true));
                    }
                  }}
                />
              ))}
          </MasonryColumn>
        ))}
      </MasonryGrid>
    );
  };

  // ===== Details skeleton =====
  const renderDetailsSkeleton = () => (
    <Content>
      <LeftSide $skeleton style={{ alignSelf: "stretch" }}>
        <SkeletonBoxImage $radius="12px" $aspectRatio={aspectRatio} />
      </LeftSide>
      <RightSide>
        <StatsContainer>
          {[1, 2, 3].map((i) => (
            <Stat key={i} style={{ gap: 6 }}>
              <SkeletonBox $width="36px" $height="24px" $radius="6px" />
              <SkeletonBox $width="52px" $height="12px" $radius="6px" />
            </Stat>
          ))}
        </StatsContainer>
        <InfoContainer>
          {[1, 2, 3, 4].map((i) => (
            <InfoRow key={i}>
              <SkeletonBox $width="70px" $height="18px" $radius="6px" />
              <SkeletonBox $width="140px" $height="20px" $radius="6px" />
            </InfoRow>
          ))}
        </InfoContainer>
        <GenerationSection>
          <SkeletonBox $width="180px" $height="24px" $radius="6px" />
          <SkeletonBox $width="100%" $height="36px" $radius="100px" />
          <SkeletonBox $width="100%" $height="250px" $radius="14px" />
          <SkeletonBox $width="100%" $height="36px" $radius="100px" />
        </GenerationSection>
      </RightSide>
    </Content>
  );

  // ===== Details tab content =====
  const renderDetailsContent = () => {
    if (isInitialCollectionLoading) return renderDetailsSkeleton();

    return (
      <Content>
        <LeftSide $aspectRatio={aspectRatio}>
          {!isMainMediaLoaded && <MediaSkeleton />}
          {isOutputImage ? (
            <MainImg
              src={displayOutputImage || displayImage}
              alt={data?.name}
              $loaded={isMainMediaLoaded}
              onLoad={() => setIsMainMediaLoaded(true)}
              onError={() => setIsMainMediaLoaded(true)}
            />
          ) : displayOutputVideo ? (
            <MainVideo
              ref={mainVideoRef}
              src={displayOutputVideo}
              poster={displayImage}
              loop
              playsInline
              autoPlay={autoPlay}
              muted
              $loaded={isMainMediaLoaded}
              onLoadedData={() => setIsMainMediaLoaded(true)}
              onError={() => setIsMainMediaLoaded(true)}
            />
          ) : (
            <MainImg
              src={displayImage}
              alt={data?.name}
              $loaded={isMainMediaLoaded}
              onLoad={() => setIsMainMediaLoaded(true)}
              onError={() => setIsMainMediaLoaded(true)}
            />
          )}
        </LeftSide>
        <RightSide>
          {(data?.ranking?.trending ||
            data?.ranking?.weekly ||
            data?.ranking?.monthly ||
            data?.ranking?.favorited) && (
            <StatsContainer>
              {data?.ranking?.trending && (
                <Stat>
                  {data?.ranking?.trending < 20 ? (
                    <StatIcon>
                      <StatValue>#{data?.ranking.trending}</StatValue>
                      <LottieIcon
                        animationData={fireLoopAnimation}
                        trigger="loop"
                        size={12}
                        loop={false}
                        autoplay={false}
                        style={{
                          position: "absolute",
                          right: -6,
                          bottom: 3.5,
                        }}
                      />
                    </StatIcon>
                  ) : (
                    <StatValue>#{data?.ranking.trending}</StatValue>
                  )}

                  <StatLabel>Trending</StatLabel>
                </Stat>
              )}
              {data?.ranking?.weekly && (
                <Stat>
                  {data?.ranking?.weekly < 20 ? (
                    <StatIcon>
                      <StatValue>#{data?.ranking?.weekly}</StatValue>
                      <LottieIcon
                        animationData={fireLoopAnimation}
                        trigger="loop"
                        size={12}
                        style={{
                          position: "absolute",
                          right: -6,
                          bottom: 3.5,
                        }}
                      />
                    </StatIcon>
                  ) : (
                    <StatValue>#{data?.ranking.weekly}</StatValue>
                  )}

                  <StatLabel>Weekly</StatLabel>
                </Stat>
              )}
              {data?.ranking?.monthly && (
                <Stat>
                  {data?.ranking?.monthly < 20 ? (
                    <StatIcon>
                      <StatValue>#{data?.ranking?.monthly}</StatValue>
                      <LottieIcon
                        animationData={fireLoopAnimation}
                        trigger="loop"
                        size={12}
                        style={{
                          position: "absolute",
                          right: -6,
                          bottom: 3.5,
                        }}
                      />
                    </StatIcon>
                  ) : (
                    <StatValue>#{data?.ranking?.monthly}</StatValue>
                  )}
                  <StatLabel>Monthly</StatLabel>
                </Stat>
              )}
            </StatsContainer>
          )}
          <InfoContainer
            $marginTop={
              data?.ranking?.trending ||
              data?.ranking?.weekly ||
              data?.ranking?.monthly ||
              data?.ranking?.favorited
            }
          >
            <InfoRow>
              <InfoLabel>Title</InfoLabel>
              <InfoValue>{data?.name}</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>Author</InfoLabel>
              <InfoValue>@{data?.username}</InfoValue>
            </InfoRow>

            {data?.description && (
              <InfoRow>
                <InfoLabel>Description</InfoLabel>
                <InfoValue>{data?.description}</InfoValue>
              </InfoRow>
            )}

            <InfoRow>
              <InfoLabel>Created</InfoLabel>
              <InfoValue>{formatDate(data?.createdAt, true)}</InfoValue>
            </InfoRow>

            {data?.keywords?.length > 0 && (
              <InfoRow>
                <InfoLabel>Categories</InfoLabel>
                <Tags>
                  {data.keywords.map((tag, i) => (
                    <Tag key={i}>{tag}</Tag>
                  ))}
                </Tags>
              </InfoRow>
            )}

            {/* {data.tags?.length > 0 && (
              <InfoRow>
                <InfoLabel>Tags</InfoLabel>
                <Tags>
                  {data.tags.map((tag) => (
                    <Tag key={tag.tagId}>{tag.name}</Tag>
                  ))}
                </Tags>
              </InfoRow>
            )} */}
          </InfoContainer>

          {isVideoModel && renderVideoGeneration()}
          {isImageModel && renderImageGeneration()}
        </RightSide>
      </Content>
    );
  };

  // ===== Grid tab content =====
  const renderGridTab = () => {
    if (activeTab === "Related")
      return renderMasonryContent(data?.related, loading);
    if (activeTab === "Extend With")
      return renderMasonryContent(data?.extend, loading);
    if (activeTab === "Same Author")
      return renderMasonryContent(sameAuthorData.data, sameAuthorData.loading);
    return null;
  };

  // =============================================
  // Main render
  // =============================================

  return (
    <MainContainer>
      <TitleContainer>
        <TitleRow>
          <BackButton onClick={handleBack}>
            <ChevronLeft />
            Back
          </BackButton>
          <ShareButton onClick={handleShare}>
            <ShareIcon />
            Share & Earn
          </ShareButton>
        </TitleRow>
        {isInitialCollectionLoading || !data ? (
          <SkeletonBox $width="150px" $height="39px" $radius="10px" />
        ) : (
          <Title>{data?.name ? formatModelName(data.name) : ""}</Title>
        )}
        <Tabs>
          {PAGE_TABS.filter((tab) => {
            if (tab.name === "Related")
              return data?.related?.length > 0 || loading;
            if (tab.name === "Extend With")
              return data?.extend?.length > 0 || loading;
            return true;
          }).map((tab) => (
            <Tab
              key={tab.id}
              $active={activeTab === tab.name}
              onClick={() => setActiveTab(tab.name)}
            >
              {tab.name}
            </Tab>
          ))}
        </Tabs>
      </TitleContainer>

      {activeTab === "Details" ? (
        renderDetailsContent()
      ) : (
        <TabContentSection>{renderGridTab()}</TabContentSection>
      )}

      {/* Video settings modal */}
      {isVideoModel && (
        <EnterPromptModal
          isOpen={isEnterPromptModalOpen}
          onClose={() => setIsEnterPromptModalOpen(false)}
          customPrompt={customPrompt}
          setCustomPrompt={setCustomPrompt}
          negativePrompt={negativePrompt}
          setNegativePrompt={setNegativePrompt}
          audioPrompt={audioPrompt}
          setAudioPrompt={setAudioPrompt}
          audioEnabled={audioEnabled}
          setAudioEnabled={setAudioEnabled}
          videoResolution={videoResolution}
          setVideoResolution={setVideoResolution}
          enableVideoQuality={!isImageOutput(data?.modelName)}
          modelPrice={
            generationTab === MODAL_CONTENT.IMAGE_TO_VIDEO
              ? (data?.price ?? 0) +
                (nudifyEnabled ? NUDIFY_PRICE : 0) +
                (upscaleEnabled ? UPSCALE_PRICE : 0)
              : (data?.price ?? 0)
          }
          setCustomSeed={setSeedNumber}
          customSeed={seedNumber}
          collectionSeed={data?.seed}
          fps={fps}
          setFps={setFps}
          videoDuration={videoDuration}
          setVideoDuration={setVideoDuration}
          setShowPrompts={setShowPrompts}
          showPrompts={showPrompts}
          isMinVideoLength8sec={data?.output.videoDuration === 8}
          collectionId={data?._id}
        />
      )}

      {/* Image settings modal */}
      {isImageModel && (
        <CustomizeEditImageModal
          isOpen={isOpenCustomizePromptModalOpen}
          onClose={() => setIsOpenCustomizePromptModalOpen(false)}
          customPrompt={customPrompt}
          setCustomPrompt={setCustomPrompt}
          seedNumber={seedNumber}
          setSeedNumber={setSeedNumber}
          generateRandomSeed={generateRandomSeed}
          collectionSeed={data?.seed}
          overlayZIndex={3600}
          isEditImageModel={
            (isEditImageModel && data?.name === "Edit Image") ||
            isDoubleInputImageModel
          }
        />
      )}

      <GenerateCollectionModal
        isOpen={isGenerateCollectionModalOpen}
        onClose={() => setIsGenerateCollectionModalOpen(false)}
      />

      <EditImageModal
        isOpen={isEditImageModalOpen}
        collection={selectedCollection}
        onClose={() => setIsEditImageModalOpen(false)}
      />

      <CreateImageModal
        isOpen={isCreateImageModalOpen}
        collection={selectedCollection}
        onClose={() => setIsCreateImageModalOpen(false)}
        overlayZIndex={isUserGalleryModalOpen ? 5000 : 3100}
      />

      <GroupModal
        isOpen={isGroupModalOpen}
        onClose={() => setIsGroupModalOpen(false)}
      />

      <UserGalleryModal
        isOpen={isUserGalleryModalOpen}
        onCreateImage={() => setIsCreateImageModalOpen(true)}
        onClose={() => setIsUserGalleryModalOpen(false)}
        onConfirm={
          shouldGenerateFromGallery
            ? handleGenerateFromGallery
            : handleUserGalleryConfirm
        }
        selectedImages={userGallerySelectedImages}
        uploadedImagesCount={0}
        maxSelectable={shouldGenerateFromGallery ? 6 : 1}
        confirmLabel={galleryConfirmLabel}
        generatePrice={collectionPrice}
        showPrice={shouldGenerateFromGallery}
        isConfirmLoading={isGeneratingFromGallery}
        allowedMediaTypes={getGalleryAllowedMediaTypes()}
        onOpenSettings={
          shouldGenerateFromGallery ? openGallerySettings : undefined
        }
      />

      <CropModal
        selectedImage={
          cropTarget === GALLERY_TARGET.TERTIARY
            ? uploadedImage3
            : cropTarget === GALLERY_TARGET.SECONDARY
              ? uploadedImage2
              : uploadedImage
        }
        onClose={() => {
          setIsOpenCropModal(false);
          setCropTarget(GALLERY_TARGET.PRIMARY);
        }}
        onConfirm={(croppedImageData) => {
          const cropped = {
            file: new File(
              [croppedImageData.blob],
              `cropped-${Date.now()}.jpg`,
              { type: "image/jpeg" },
            ),
            url: croppedImageData.url,
            blob: croppedImageData.blob,
          };

          if (cropTarget === GALLERY_TARGET.TERTIARY) {
            setUploadedImage3(cropped);
          } else if (cropTarget === GALLERY_TARGET.SECONDARY) {
            setUploadedImage2(cropped);
          } else {
            setUploadedImage(cropped);
          }
        }}
        isOpen={isOpenCropModal}
      />
    </MainContainer>
  );
};

export default CollectionDetailsPage;
